export enum enumPaymentStatus {
    PROCESSING = 1,
    PAYED = 2,
    NOT_PAYED = 3,
}